import {
  ENDPOINT_ADMIN_MAINTENANCE_DISABLE,
  ENDPOINT_ADMIN_MAINTENANCE_ENABLE,
  ENDPOINT_ADMIN_MAINTENANCE_GET
} from "../../constants/api";

const Emitter = require('mn-utils/Emitter');
const {
  apiRequestAdmin,
} = require('../ws');

const mockMaintenanceMode$ = new Emitter(false);


export function apiAdminMaintenanceGet(params) {
  return apiRequestAdmin(ENDPOINT_ADMIN_MAINTENANCE_GET, params, () => {
    return {
      enabled: mockMaintenanceMode$.getValue(),
    };
  });
}
export function apiAdminMaintenanceEnable(params) {
  return apiRequestAdmin(ENDPOINT_ADMIN_MAINTENANCE_ENABLE, params, () => {
    mockMaintenanceMode$.emit(true);
  });
}
export function apiAdminMaintenanceDisable(params) {
  return apiRequestAdmin(ENDPOINT_ADMIN_MAINTENANCE_DISABLE, params, () => {
    mockMaintenanceMode$.emit(false);
  });
}
